import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Intuit App Store "Launch URL" + "Connect/Reconnect URL" landing.
// Signed-in operators go straight to the QuickBooks integration card;
// everyone else goes to login first.
export default function QuickBooksLaunchPage() {
  const navigate = useNavigate();
  useEffect(() => {
    const authed = !!localStorage.getItem('jwtToken');
    navigate(authed ? '/admin?tab=conversions&qbo=launch' : '/login', { replace: true });
  }, [navigate]);
  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="qbo-launch-page">
      <div className="w-8 h-8 border-2 border-[#2CA01C] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
